import {ready} from 'dauphine-js';
import Filters from "./components/_filters";
import JsChoices from "./components/_choices";
import {EventBus} from './utils/_event-bus';

window.EventBus = EventBus;

if (typeof console == "undefined") {
    this.console = {log: function() {}};
}

Filters.init();
JsChoices.init();

ready(() => {
    require('./components/menu/_menu');
    require('./components/_sliders');
    require('./components/_parallax');
    require('./components/_accordion');
    require('./components/_login');
    require('./components/_newsletter');
    require('./components/_search');
    require('./components/_password');
});
